@app.controller 'jouleFeatures', (AnalyticsService) ->

  @track = ->
    AnalyticsService.track 'Button Clicked - Joule Specs Link'

  this
